var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{staticClass:"special-field",attrs:{"id":`special-${_vm.name}-field`,"name":_vm.name,"type":"password","autocomplete":"new-password"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"paste":_vm.onPaste}})
}
var staticRenderFns = []

export { render, staticRenderFns }